import { Button, ButtonGroup, Text, Tooltip } from '@chakra-ui/react';
import { DiDatabase } from 'react-icons/di';
import { GoFileDirectory } from 'react-icons/go';
import { PrimaryStorage } from '../../../core/redux/auth/authTypes';
import { useTranslation } from 'react-i18next';

// #region variables and types
const providers = [
  { name: PrimaryStorage.IndexedDB, icon: <DiDatabase size={25} /> },
  { name: PrimaryStorage.FileSystem, icon: <GoFileDirectory size={25} /> },
];


interface PrimaryStorageButtonGroupProps {
  storage: PrimaryStorage;
  changePrimaryStorage: (storage: PrimaryStorage) => void;
}
// #endregion

const PrimaryStorageButtonGroup: React.FC<PrimaryStorageButtonGroupProps> = ({
  storage,
  changePrimaryStorage,
}) => {
  const { t } = useTranslation();
  const fsLabel = t('login.folderPermission');
  // #region buttn view
  const buttonView = (name: PrimaryStorage, icon: JSX.Element) => {
    const label = name === PrimaryStorage.FileSystem && fsLabel;
    return (
      <Tooltip key={name} label={label} p={3} borderRadius={10} hasArrow={true}>
        <Button
          width="full"
          isActive={storage === name}
          onClick={() => changePrimaryStorage(name)}
        >
          {icon}
          <Text fontSize={'md'} ml="5">
            {name}
          </Text>
        </Button>
      </Tooltip>
    );
  };
  // #endregion

  return (
    <ButtonGroup variant="outline" spacing="4" width="full">
      {providers.map(({ name, icon }) => buttonView(name, icon))}
    </ButtonGroup>
  );
};

export default PrimaryStorageButtonGroup;
